module.exports = __webpack_public_path__ + "assets/img/security.54ed1239.jpg";